<template>
  <div class="page">
    <div class="path">
      <span class="normal pointer" @click="toEcology()">生态服务</span>
      <span class="normal space">/</span>
      <span class="active">个人能力申请详情</span>
    </div>
    <div class="content">
      <div class="title">
        <h2>
          能力资格申请
          <span
            class="tag"
            :class="['tag' + dataSource.supplierUserAbilityApplyStatus]"
            v-if="dataSource.supplierUserAbilityApplyStatusStr"
            >{{ dataSource.supplierUserAbilityApplyStatusStr }}</span
          >
        </h2>

        <div class="flex">
          <div class="info-item inline-item">
            <div class="label">申请单号:</div>
            <div class="value">{{ dataSource.supplierUserAbilityApplyNo }}</div>
          </div>
          <div class="info-item inline-item">
            <div class="label">评审意见:</div>
            <div class="value">{{ dataSource.bpmReviewComments || "-" }}</div>
          </div>
        </div>
        <div class="flex">
          <div class="info-item inline-item">
            <div class="label">申请人:</div>
            <div class="value">{{ dataSource.createName || "-" }}</div>
          </div>
          <div class="info-item inline-item">
            <div class="label">申请时间:</div>
            <div class="value">{{ dataSource.createTime || "-" }}</div>
          </div>
        </div>
        <div>
          <!-- 待提审、已驳回 时显示 -->
          <el-button
            v-if="[1, 3].includes(+dataSource.supplierUserAbilityApplyStatus)"
            type="primary"
            size="small"
            @click="onSubmit()"
            >提交审批</el-button
          >
          <el-button
            v-if="[3].includes(+dataSource.supplierUserAbilityApplyStatus)"
            type="danger"
            plain
            size="small"
            @click="onCancel()"
            >作废申请</el-button
          >
          <el-button
            v-if="[1, 3].includes(+dataSource.supplierUserAbilityApplyStatus)"
            plain
            size="small"
            @click="onEdit()"
            >编辑</el-button
          >
        </div>
      </div>
      <div>
        <h3>申请信息</h3>
        <div>
          <div class="info-item">
            <div class="label">申请能力:</div>
            <div class="value">
              <div class="bold-tag">
                {{ dataSource.ability1 }}/{{ dataSource.ability2 }}/{{
                  dataSource.ability3
                }}
              </div>
            </div>
          </div>
          <div class="info-item">
            <div class="label">证明材料:</div>
            <div class="value">
              <div
                class="mb-16"
                v-for="item in dataSource.proofFiles"
                :key="item.ossId"
              >
                <a :href="item.url" target="_blank">{{ item.fileName }}</a>
              </div>
            </div>
          </div>
          <div class="info-item">
            <div class="label">申请备注:</div>
            <div class="value">{{ dataSource.remark }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      id: "",
      dataSource: {},
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.getDataSource();
  },
  methods: {
    onEdit() {
      this.$router.push({
        name: "ecologicalServices-person-edit",
        query: { id: this.id },
      });
    },
    onCancel() {
      this.$http
        .post(`/front/oms/userAbilityApply/cancel`, { id: this.id, status: 0 })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message.success("作废成功");
            // 刷新数据
            this.getDataSource();
          }
        });
    },
    onSubmit() {
      this.$http
        .post(`/front/oms/userAbilityApply/submit`, { id: this.id })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message.success("提交成功");
            // 刷新数据
            this.getDataSource();
          }
        });
    },
    getDataSource() {
      this.$http
        .get(`/front/oms/userAbilityApply/userApplyAbilityQuery/${this.id}`)
        .then(({ data: res }) => {
          const { code, data } = res;
          if (code === 0) {
            this.dataSource = data;
          }
        });
    },
    toEcology() {
      this.$router.push({ name: "ecologicalServices" });
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
}
.path {
  height: 36px;
  line-height: 36px;
  .normal {
    font-family: Alibaba PuHuiTi;
    font-size: 14px;
    color: #999999;
  }
  .active {
    font-family: Alibaba PuHuiTi;
    font-size: 14px;
    font-weight: 600;
    color: #333333;
  }
  .space {
    margin-right: 8px;
    margin-left: 8px;
  }
}
.content {
  background: #fff;
  padding: 20px;
  min-height: 800px;
}
h2 {
  font-family: Alibaba PuHuiTi;
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
}
h3 {
  font-family: Alibaba PuHuiTi;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
}
.el-button--primary {
  background-color: #2a54d1;
  border-color: #2a54d1;
  &:hover {
    opacity: 0.9;
  }
}
.title {
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}
.label {
  font-family: Alibaba PuHuiTi;
  font-size: 14px;
  text-align: right;
  color: #666666;
  padding-right: 8px;
}
.value {
  flex: 1;
  font-family: Alibaba PuHuiTi;
  font-size: 14px;
  font-weight: 600;
  color: #333333;
}
.flex {
  display: flex;
}
.info-item {
  display: flex;
  margin-bottom: 20px;
  a {
    font-size: 14px;
    font-weight: 600;
    text-align: right;
    color: #2a54d1;
  }
}
.mb-16 {
  margin-bottom: 16px;
}
.bold-tag {
  border-radius: 4px;
  padding: 6.5px 18px;
  background: #2a54d1;
  display: inline-block;
  font-family: AlibabaPuHuiTi;
  font-size: 14px;
  color: #ffffff;
}
.inline-item {
  width: 300px;
}
.tag {
  border-radius: 14px;
  padding: 2px 8px;

  font-family: Alibaba PuHuiTi;
  font-size: 12px;
  font-weight: normal;
  color: #ffffff;
  margin-left: 12px;
}
//  1. 待提审 2. 审批中 3. 已驳回 4. 已生效 5.已取消
.tag1 {
  background: #e5a92f;
}
.tag2 {
  background: #2a54d1;
}
.tag3 {
  background: #e93037;
}
.tag4 {
  background: #1fbd13;
}
.tag5 {
  background: #eee;
  color: #000;
}
.pointer {
  cursor: pointer;
}
.between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>